module.exports = __webpack_public_path__ + "79d31b264462bd774d823dbafe96bb7b.fbx";